import React from "react";
import "../../stylesheet/components/contentcards/CardTag.scss";

const CardTag: React.FC<{ title: string }> = ({ title }) => {
  return <div className="card-tag">{title}</div>;
};

export default CardTag;
